import { FC } from "react";

import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import Slide from "@material-ui/core/Slide";
import { Button } from "@runwayhealth/runway-components-react";
import { Condition } from "@types-runway/condition";

import {
  CloseButtonWrapper,
  ContentWrapper,
  FullScreenCloseButtonWrapper,
  FullScreenContentWrapper,
} from "./components/ContentWrapper";

type SliderProps = {
  open: boolean;
  close: () => void;
  child: FC;
  condition?: Condition;
  fullScreen?: boolean;
};

const OverlayPanel: FC<SliderProps> = ({
  open,
  close,
  child: Child,
  condition,
  fullScreen = false,
}: SliderProps) => {
  // Fullscreen mode for payment flows
  if (fullScreen) {
    return (
      <div className="modalVisible">
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={() => close()}
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Fade in={open} timeout={300}>
            <FullScreenContentWrapper>
              <FullScreenCloseButtonWrapper>
                <Button
                  size="md"
                  iconName={"X"}
                  variant="outline"
                  onClick={() => {
                    close();
                  }}
                  isIconOnly
                />
              </FullScreenCloseButtonWrapper>
              <Child />
            </FullScreenContentWrapper>
          </Fade>
        </Modal>
      </div>
    );
  }

  // Standard side panel mode
  return (
    <div className="modalVisible">
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => close()}
        style={{ alignItems: "center", justifyContent: "center" }}
      >
        <Slide direction="left" in={open} mountOnEnter unmountOnExit>
          <ContentWrapper>
            <CloseButtonWrapper>
              <Button
                size="sm"
                iconName={"X"}
                variant="outline"
                onClick={() => {
                  close();
                }}
                isIconOnly
              />
            </CloseButtonWrapper>
            <Child />
          </ContentWrapper>
        </Slide>
      </Modal>
    </div>
  );
};

export default OverlayPanel;
